import * as React from "react";
import type { SVGProps } from "react";

interface TouchdownProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Touchdown = ({ cancelled = false, ...props }: TouchdownProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M6.14 4.85C.62 9.37-1.5 16.27 1.84 20.44c3.34 4.18 10.5 3.51 16.01-1.01C23.37 14.9 25.5 8 22.15 3.83 18.82-.34 11.66.34 6.15 4.86Zm1.1 1.35C12.1 2.22 18.18 1.65 20.8 4.93c2.63 3.28.81 9.16-4.04 13.14-4.86 3.98-10.93 4.55-13.55 1.28C.58 16.07 2.4 10.18 7.26 6.2Z"
      />
      <path
        fill="#BC6264"
        fillRule="nonzero"
        d="M7.25 6.2c4.85-3.98 10.92-4.55 13.54-1.27 2.63 3.28.81 9.16-4.04 13.14-4.86 3.98-10.93 4.55-13.55 1.28-2.63-3.28-.81-9.17 4.05-13.15"
      />
      <path
        fill="#FFF"
        d="M2.46 11.48c1.44 2.5 2.61 4.3 3.51 5.43s2.4 2.65 4.48 4.56l-3.47.87-5.48-7.36zm19.03 1.29a47 47 0 0 0-3.52-5.44c-.9-1.12-2.39-2.65-4.47-4.56l3.47-.87 5.48 7.36-.96 3.5Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M15.33 6c.2.29.15.7-.14.9l-.74.55-.4.3.48.54a.5.5 0 0 1-.75.66l-.53-.6-.83.63.5.56a.5.5 0 0 1-.76.66l-.53-.61-.84.67.51.58a.5.5 0 0 1-.75.66l-.53-.6-.35.3-.17.15-.23.2.5.54a.5.5 0 0 1-.72.69l-.52-.56-.83.8.54.55a.5.5 0 1 1-.72.7l-.53-.56-1.03 1.04a.65.65 0 1 1-.93-.9l1.05-1.07-.53-.55a.5.5 0 1 1 .72-.7l.53.55c.28-.28.56-.54.85-.8l-.53-.57a.5.5 0 1 1 .73-.68l.54.57.25-.23.37-.33.16-.13-.48-.55a.5.5 0 0 1 .75-.65l.5.56.84-.66-.47-.55a.5.5 0 0 1 .75-.65l.5.58.84-.63-.48-.55a.5.5 0 1 1 .76-.65l.52.6 1.22-.9c.29-.21.7-.15.9.14Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M6.61 5.43C11.85 1.13 18.54.5 21.57 4.3s1.04 10.26-4.2 14.55c-5.23 4.29-11.92 4.92-14.95 1.12-3.03-3.79-1.04-10.25 4.2-14.54Zm14.18-.5C18.17 1.65 12.1 2.23 7.25 6.2 2.39 10.18.57 16.07 3.2 19.35c2.62 3.27 8.69 2.7 13.55-1.28 4.85-3.98 6.67-9.86 4.04-13.14"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Touchdown;
